"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class CloseIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12" },
            React.createElement("path", { fill: fill, fillRule: "evenodd", d: "M10.586 0L6 4.586 1.414 0 0 1.414 4.586 6 0 10.586 1.414 12 6 7.414 10.586 12 12 10.586 7.414 6 12 1.414 10.586 0" })));
    }
}
exports.CloseIcon = CloseIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/close.tsx
// module id = 2134
// module chunks = 0 1 2